import { useFlocknoteAppState } from "Flocknote/state";
import { useHasGivingTab } from "Flocknote/stateHooks";

import useIsMobile from "Utilities/Hooks/useIsMobile";
import useUrlParams from "Utilities/Hooks/useUrlParams";
import { useAddUrlParam } from "Utilities/urlParamHooks";

import { useProfileSidebarContext } from "../ProfileSidebar/ProfileSidebar";

import SidebarLinkButton from "./SidebarLinkButton";

const GoToGivingTab = () => {
  const addUrlParam = useAddUrlParam();
  const { profileTab } = useUrlParams();
  const { setShowHousehold } = useProfileSidebarContext();
  const showGiving = useHasGivingTab();
  const [{ loadingProfileTab }] = useFlocknoteAppState();

  const isViewingGivingInfo = profileTab === "giving";

  const isMobile = useIsMobile(680);

  const handleClick = () => {
    window.fnReactBus.navigateToProfileTab("giving");
    addUrlParam("profileTab", "giving");

    if (isMobile) setShowHousehold(false);
  };

  if (!showGiving) return null;

  return (
    <SidebarLinkButton
      onClick={handleClick}
      loading={loadingProfileTab === "giving"}
      isActive={isViewingGivingInfo}
      icon={`money-check-alt ${isViewingGivingInfo ? "fas" : "far"}`}
      text="Giving"
      data-cy="GoToGivingTab"
    />
  );
};

export default GoToGivingTab;
